/**
 * Use a type guard to check if httpStatus property exists in an unknown object
 */
export function hasHttpStatus(obj: unknown): obj is { httpStatus: unknown } {
    return typeof obj === 'object' && obj !== null && 'httpStatus' in obj;
}
